import { useState, useEffect } from "react";
import PrivacyPolicy from "../components/Terms/PrivacyPolicyComponent";
import TermsConditions from "../components/Terms/TermsConditionComponent";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

type TabType = 'privacy' | 'terms';

const TermsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    const [activeTab, setActiveTab] = useState<TabType>('privacy');

    const handleTabClick = (tab: TabType) => {
        setActiveTab(tab);
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top smoothly
    };

    return (
        <>      
    <HelmetProvider>
        <Helmet>
          <title>Terms & Conditions | Halo Holidays</title>
          <meta name="description" content="Read our terms and conditions for booking your holiday with Halo Holidays." />
        </Helmet>
    </HelmetProvider>
            <Header />
            <div className="container mx-auto mt-20 p-4">
                <div className="md:flex md:space-x-8">
                    <div className="flex md:flex-col space-x-2 md:space-x-0 md:space-y-4 md:w-1/4 mb-4 md:mb-0 sticky-on-mobile1 bg-white">
                        <button
                            onClick={() => handleTabClick('privacy')}
                            className={`w-full md:w-auto p-4 text-center border-2 rounded-lg transition-all ${activeTab === 'privacy' ? 'border-halo-pink bg-halo-light-pink font-bold' : 'border-gray-300'}`}
                        >
                            Privacy Policy
                        </button>
                        <button
                            onClick={() => handleTabClick('terms')}
                            className={`w-full md:w-auto p-4 text-center border-2 rounded-lg transition-all ${activeTab === 'terms' ? 'border-halo-pink bg-halo-light-pink font-bold' : 'border-gray-300'}`}
                        >
                            Cookie Policy
                        </button>
                    </div>
                    <div className="md:w-3/4 border-t md:border-t-0 md:border-l px-4 py-6 md:py-0 mt-14 md:mt-0">
                        {activeTab === 'privacy' && <PrivacyPolicy />}
                        {activeTab === 'terms' && <TermsConditions />}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TermsPage;
